// extracted by mini-css-extract-plugin
export default {"contactCol":"GuideContact_contactCol__ygr7P"};